module.exports = __webpack_public_path__ + "assets/media/2.584bd721.wav";